import TextStyle from "@tiptap/extension-text-style";

// TextStyle extra: background-color (highlight)
// Usage:
// - editor.chain().setBackgroundColor("#fff7cc").run()
// - editor.chain().unsetBackgroundColor().run()
export const TextBackgroundColor = TextStyle.extend({
  name: "textBackgroundColor",
  addGlobalAttributes() {
    return [
      {
        types: ["textStyle"],
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (element) => element.style.backgroundColor?.replace(/['"]/g, "") || null,
            renderHTML: (attributes) => {
              if (!attributes.backgroundColor) return {};
              return { style: `background-color: ${attributes.backgroundColor}` };
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setBackgroundColor:
        (backgroundColor) =>
        ({ chain }) => {
          return chain().setMark("textStyle", { backgroundColor }).run();
        },
      unsetBackgroundColor:
        () =>
        ({ chain }) => {
          return chain().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run();
        },
    };
  },
});



